import { call, takeLatest } from "redux-saga/effects";
import * as resourceApis from "../apis/resourceApis"
import { ASSIGN_PORTAL_GLOSSARY, CREATE_GLOSSARY, DELETE_GLOSSARY, LIST_GLOSSARY, PORTALS_DROP_DOWN, UPLOAD_CSV_FILE } from "../actions/types";

export function* uploadCsvFileWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(resourceApis.uploadCsvFileApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* createGlossaryWorker(action) {
    try {
        const res = yield call(resourceApis.createGlossaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* glossaryListWorker(action) {
    try {
        const res = yield call(resourceApis.glossaryListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteGlossaryWorker(action) {
    try {
        const res = yield call(resourceApis.deleteGlossaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* assignPortalGlossaryWorker(action) {
    try {
        const res = yield call(resourceApis.assignPortalGlossaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* portalsDropDownWorker(action) {
    try {
        const res = yield call(resourceApis.portalsDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher functions */

export function* uploadCsvFileWatcher() {
    yield takeLatest(UPLOAD_CSV_FILE, uploadCsvFileWorker);
}

export function* createGlossaryWatcher() {
    yield takeLatest(CREATE_GLOSSARY, createGlossaryWorker);
}

export function* listGlossaryWatcher() {
    yield takeLatest(LIST_GLOSSARY, glossaryListWorker);
}

export function* deleteGlossaryWatcher() {
    yield takeLatest(DELETE_GLOSSARY, deleteGlossaryWorker);
}

export function* assignPortalGlossaryWatcher() {
    yield takeLatest(ASSIGN_PORTAL_GLOSSARY, assignPortalGlossaryWorker);
}

export function* portalsDropDownWatcher() {
    yield takeLatest(PORTALS_DROP_DOWN, portalsDropDownWorker);
}